var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYandex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "red"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 24h-7l8-18h7l-8 18zm-5 12.689c0-4.168-.953-8.357-2.758-12.117L15 6H8l10.833 21.169A22.132 22.132 0 0121 36.689V42h6v-5.311z"
  })));
}

export default SvgYandex;